import React from 'react'
import PropTypes, { bool, number, string } from 'prop-types'
import { useSelector } from 'react-redux'
import TextField from 'components/formFields/textField'
import { NUBANK_COMPANY_ID } from 'utils/constants'

const LegalNationality = ({ name, optional, fieldType, ...fieldProps }) => {
	const { company_id } = useSelector(({ session }) => session)

	const pageFieldsData = {
		info: '',
		type: 'text',
		label: company_id === NUBANK_COMPANY_ID ? 'Nationality' : 'Nacionalidade',
		list: name,
		optional: optional,
		variable: {
			name: fieldType.toUpperCase(),
			type: 'string',
			doc_display_style: 'plain',
		},
	}

	return <TextField {...fieldProps} pageFieldsData={pageFieldsData} />
}

LegalNationality.propTypes = {
	name: PropTypes.oneOfType([number, string]),
	optional: bool,
	fieldType: string,
}

export default LegalNationality
